/// <amd-module name="Agile/Common/Redux/BacklogConfiguration/BacklogConfigurationSelectors" />
import { CaseInsensitiveMap, IStringMap } from "Agile/Common/DataStructures";
import { IBacklogConfiguration } from "Agile/Common/Redux/BacklogConfiguration/BacklogConfigurationContracts";
import * as Reselect from "Reselect";
import { BacklogFieldTypes, IBacklogConfigurationAwareState, StateToCategoryMap } from "./BacklogConfigurationContracts";

export const getBacklogConfiguration = (state: IBacklogConfigurationAwareState): IBacklogConfiguration => state.backlogConfiguration;
export function getTeamFieldRefName(state: IBacklogConfigurationAwareState): string {
    const backlogConfiguration = state.backlogConfiguration;
    return backlogConfiguration.backlogFields.typeFields[BacklogFieldTypes.Team];
}
export function getEffortFieldRefName(state: IBacklogConfigurationAwareState): string {
    const backlogConfiguration = state.backlogConfiguration;
    return backlogConfiguration.backlogFields.typeFields[BacklogFieldTypes.Effort];
}

export const getStateCategoriesByWorkItemType = Reselect.createSelector(
    getBacklogConfiguration,
    (backlogConfiguration: IBacklogConfiguration): IStringMap<StateToCategoryMap> => {
        const map = new CaseInsensitiveMap<StateToCategoryMap>();
        return backlogConfiguration.workItemTypeMappedStates.reduce((prev, cur) => {
            return prev.set(cur.workItemTypeName, cur.states);
        }, map);
    }
);

export function getRequirementWorkItemTypes(state: IBacklogConfigurationAwareState): string[] {
    const backlogConfiguration = state.backlogConfiguration;
    return backlogConfiguration.requirementBacklog.workItemTypes;
}

export function getRequirementDefaultWorkItemType(state: IBacklogConfigurationAwareState): string {
    const backlogConfiguration = state.backlogConfiguration;
    return backlogConfiguration.requirementBacklog.defaultWorkItemType;
}

export function getTaskWorkItemTypes(state: IBacklogConfigurationAwareState): string[] {
    const backlogConfiguration = state.backlogConfiguration;
    return backlogConfiguration.taskBacklog.workItemTypes;
}
